// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"542":"6ef35b48ea26ae98","4901":"7548650749163d8a","5145":"7af77e1c463eb937"}[chunkId] + ".css";
};